import React, { useState } from "react";
import { Chip, Button } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DatosCita.css";
import EditarUsuario from "../Usuarios/EditarUsuario";

const formatDate = (dateTimeStr) => {
  if (!dateTimeStr) return "";

  const date = new Date(dateTimeStr);

  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
  });
};

const formatTime = (dateTimeStr) => {
  if (!dateTimeStr) return "";

  const date = new Date(dateTimeStr);

  return date.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const DatosCita = ({ citaData }) => {
  const [formData, setFormData] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [clienteId, setClienteId] = useState(null);

  const handleEditarClick = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/clientes/${citaData.id_cliente}`
      );

      if (!response.ok) {
        throw new Error("Error al obtener cliente");
      }

      const data = await response.json();

      console.log("CLIENTE:", data);

      setFormData({
        nombre: data.nombre,
        apellido: data.apellido,
        telefono: data.telefono || "",
        observaciones: data.observaciones || "",
      });

      setHistorial(data.ultimos_tickets || []);

      setClienteId(citaData.id_cliente);
      setOpenModal(true);
    } catch (error) {
      console.error("Error obteniendo cliente:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const clienteActualizado = {
        nombre_cliente: formData.nombre,
        apellidos_cliente: formData.apellido,
        telefono: formData.telefono || null,
        observaciones: formData.observaciones || null,
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/clientes/${clienteId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(clienteActualizado),
        }
      );

      if (!response.ok) {
        throw new Error("Error al actualizar cliente");
      }

      setOpenModal(false);
    } catch (error) {
      console.error("Error actualizando cliente:", error);
    }
  };

  return (
    <div className="datos-cita-box p-3">
      {/* Fila superior */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center gap-2">
          <Chip
            label={`#${citaData.id_cita}`}
            size="small"
            color="primary"
            variant="outlined"
          />

          <Chip
            label={`Puesto ${citaData.id_puesto}`}
            size="small"
            color="secondary"
          />
        </div>

        <div className="text-end">
          <div className="fecha-hora">
            {formatDate(citaData.fecha_hora)} ·{" "}
            {formatTime(citaData.fecha_hora)}
          </div>
        </div>
      </div>

      {/* Cliente */}
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="nombre-cliente">
            {citaData.nombre_cliente} {citaData.apellidos_cliente}
          </div>

          <div className="telefono text-muted">
            {citaData.telefono || "Sin teléfono"}
          </div>
        </div>

        <Button
          variant="outlined"
          onClick={handleEditarClick}
        >
          Ver INFO CLIENTE
        </Button>
      </div>

      {formData && (
        <EditarUsuario
          open={openModal}
          onClose={() => setOpenModal(false)}
          formData={formData}
          historial={historial}
          onFormChange={handleChange}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default DatosCita;